<template>
  <div class="main-entrance-container">
    <transition name="slide-fade">
      <Default key="Default" v-if="currentMenu==='default'" />
      <MyCollection key="MyCollection" v-if="currentMenu==='myCollection'" />
      <AllFiles key="AllFiles" v-if="currentMenu==='allFiles'" />
      <ExpiredFiles key="ExpiredFiles" v-if="currentMenu==='expiredFiles'" />
    </transition>
  </div>
</template>

<script>
import Default from './components/default.vue';
import ExpiredFiles from './components/expired.vue';
import MyCollection from './components/myCollection.vue';
import AllFiles from './components/allFiles.vue';
export default {
  components: {
    Default,
    ExpiredFiles,
    MyCollection,
    AllFiles
  },
  props: {
    currentMenu: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.main-entrance-container {
  min-width: calc(100% - 300px);
  width: 84%;
  height: 100%;
  .con {
    height: 100%;
  }
  .slide-fade-enter-active {
    transition: all 0.3s ease 0.1s;
  }
  .slide-fade-enter {
    transform: translateX(-2%);
    opacity: 0;
  }
}
</style>